export default {
  /////////////////
  // COMPANY OBJECTS
  /////////////////

  SET_TREE_STATISTIC(state, statistic) {
    state.treeStatistic = statistic
  },
  SET_LIST_FORESTS(state, items) {
    state.forests = items
  },



  SET_ANINAL_TABLE(state, items) {
    state.animalTable = items
  },
  SET_ANIMAL_STATISTIC(state, items) {
    state.animalStatistic = items
  },
  SET_LIST_AMIMALS(state, items) {
    state.animals = items
  },
  SET_TYPES_AMIMALS(state, items) {
    state.animalsTypes = items
  },

  // SET_COMPANY_OBJECTS(state, objects) {
  //   state.objects = objects
  // },
  // ADD_COMPANY_OBJECTS(state, objects) {
  //   state.objects.push(objects)
  // },
  // EDIT_COMPANY_OBJECTS(state, value) {
  //   const userIndex = state.objects.findIndex((u) => u.id === value.id)
  //   state.objects.splice(userIndex, 1, value)
  // },

};
